<template>
  <div>
    <v-dialog v-model="is_generate_invoice_for_cost_plus" max-width="1100" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline">Invoice</v-card-title>
        <v-card-text class>
          <v-data-table
            class="elevation-1 mt-1 rounded-0 my-transaction-table"
            :items="items"
            hide-default-footer
            mobile-breakpoint="50"
            disable-pagination
            dense
            fixed-header
            style="max-height:500px;overflow-y:auto;"
          >
            <template v-slot:body.prepend>
              <tr class="header-background white-border right-border-white">
                <td width="5%" class="text-center">A</td>
                <td width="30%" class="text-left">B</td>
                <td width="15%" class="text-right pr-9">C</td>
                <td width="15%" class="text-right pr-8">D</td>
                <td width="15%" class="text-right pr-8">E</td>
                <td width="15%" class="text-right pr-8">f</td>
              </tr>
              <tr class="header-background right-border-white">
                <td width="5%" class="text-center">
                  Item
                  <br />No.
                </td>
                <td width="30%" class="text-left">Description of work</td>
                <td width="15%" class="text-right">
                  Current
                  <br />Amt. Spent
                </td>
                <td width="15%" class="text-right">
                  Previous
                  <br />Invoice Amt
                </td>
                <td width="15%" class="text-right">
                  Current
                  <br />Invoice Amt
                </td>
                <td width="15%" class="text-right">
                  Total
                  <br />Amount
                </td>
              </tr>
            </template>
            <template v-slot:item="{ item, index}">
              <tr class="right-border-grey">
                <td width="10%" style="text-align:center;">{{index+1}}</td>
                <td width="30%" style="text-align:left;">{{item.group_name}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="item.total_group_amount < 0 ? 'error--text' : (item.total_group_amount == 0  ?  ''  :  'primary--text')"
                >${{getAmountFormat(item.total_group_amount)}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="item.previous_group_amount < 0 ? 'error--text' : (item.previous_group_amount == 0  ?  ''  :  'primary--text')"
                >${{getAmountFormat(item.previous_group_amount)}}</td>

                <td
                  width="15%"
                  style="text-align:right;"
                  :class="item.final_group_amount < 0 ? 'error--text' : (item.final_group_amount == 0  ?  ''  :  'primary--text')"
                >
                  ${{getAmountFormat(item.final_group_amount)}}
                  <v-icon @click="changeTranAmtDialog(item)">mdi-border-color</v-icon>
                </td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="item.last_group_amount < 0 ? 'error--text' : (item.last_group_amount == 0  ?  ''  :  'primary--text')"
                >${{getAmountFormat(item.last_group_amount)}}</td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr class="grey-lighten-background right-border-grey">
                <td width="5%"></td>
                <td width="30%" style="text-align:left;">Total</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="previous_amt < 0 ? 'error--text' : '' "
                >${{getAmountFormat(total_amt)}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="previous_amt < 0 ? 'error--text' : '' "
                >${{getAmountFormat(previous_amt)}}</td>
                <td
                  width="15%"
                  style="text-align:right;margin-right:20px;"
                  :class="final_amt < 0 ? 'error--text' : '' "
                >
                  <span>${{getAmountFormat(final_amt)}}</span>
                </td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="last_amt < 0 ? 'error--text' : '' "
                >${{getAmountFormat(last_amt)}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="$emit('closeDialog')" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>

          <v-btn
            :loading="loading"
            color="primary"
            class="pr-3 text-capitalize"
            @click="generateInvoice()"
            :disabled="generate_btn_flag"
          >{{is_update_invoice ? 'Update Invoice' : 'Save Invoice' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="change_tran_amt_dialog" max-width="1200" persistent>
      <v-card :loading="generate_invoice_loading">
        <v-card-title class="headline">Update Invoice Amount</v-card-title>
        <v-card-text class>
          <v-simple-table dense>
            <thead style="background: #455a64;">
              <tr class="grey-lighten-background right-border-grey">
                <td width="40%">
                  <b>{{this.selected_group.group_name}}</b>
                </td>
                <td width="20%"></td>
                <td>Scheduled :</td>
                <td>${{parseFloat(this.selected_group.total_group_amount).toFixed(2)}}</td>
                <td style="text-align:right">Previous :</td>
                <td>${{parseFloat(this.selected_group.total_group_amount).toFixed(2)}}</td>
              </tr>
            </thead>
          </v-simple-table>
          <v-simple-table dense class="mt-5">
            <thead style="background: #455a64;">
              <tr>
                <td width="10%" class="white--text">Bank</td>
                <td width="10%" class="white--text">Date</td>
                <td width="12%" class="white--text text-right">Amount</td>
                <td width="12%" class="white--text">Vendor</td>
                <td width="16%" class="white--text">INV Amt</td>
                <td width="40%" class="white--text">Description</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in trans_items" :key="index" class="mt-3">
                <td>{{row.bank_id ? row.bank.bank_code : '' }}</td>
                <td>{{ getFormatedDate(row.trans_date) }}</td>
                <td class="text-right">
                  <div>
                    <span
                      :class="{
                        'error--text': row.rev_amount < 0,
                        'primary--text': row.rev_amount > 0,
                      }"
                    >${{ getAmountFormat(row.rev_amount) }}</span>
                  </div>
                </td>
                <td>
                  <v-tooltip bottom v-if="row.expence">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >{{ (row.expance_details)?row.expance_details.bank_code:'' }}</span>
                    </template>
                    <span>{{ (row.expance_details)?row.expance_details.bank_name:'' }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ (row.vendor)?row.vendor.v_code:'' }}</span>
                    </template>
                    <span>{{ (row.vendor)?row.vendor.v_name:'' }}</span>
                  </v-tooltip>
                </td>
                <td
                  :class="{  'error--text': row.inv_amt < 0,  'primary--text': row.inv_amt > 0, }"
                >
                  <v-text-field
                    style="margin-top: -2px;"
                    v-model="row.display_inv_amt"
                    type="number"
                    dense
                    hide-details
                    :class="{
                        'error--text': row.inv_amt < 0,
                        'primary--text': row.inv_amt > 0,
                      }"
                    @input="getTotalUpdatevalue()"
                  ></v-text-field>
                </td>
                <td>
                  <div>
                    <v-tooltip left max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                          class="d-inline-block"
                          style="word-break: break-all;"
                          v-html="row.description.substring(0,40)"
                        >
                          <span v-if="row.description.length > 40">..</span>
                        </span>
                      </template>
                      <span>{{ row.description }}</span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
              <tr class="grey-lighten-background right-border-grey">
                <td></td>
                <td></td>
                <td class="text-right">${{getTransacionVal()}}</td>
                <td></td>
                <td
                  :class="updated_amt_total < 0 ? 'error--text' : 'primary--text' "
                >${{parseFloat(this.display_updated_amt_total).toFixed(2)}}</td>
                <td></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="change_tran_amt_dialog = false"
            :disabled="generate_invoice_loading"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="generate_invoice_loading"
            color="primary"
            class="pr-3 text-capitalize"
            @click="updateInvoiceAmt()"
            :disabled="invoice_btn_flag"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import moment from "moment";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      loading: false,
      generate_invoice_loading: false,
      items: [],
      trans_items: [],
      selected_group: {},
      change_tran_amt_dialog: false,
      invoice_btn_flag: false,
      generate_btn_flag: false,
      last_match_balance_value: "",
      updated_amt_total: 0,
      display_updated_amt_total: 0,
      has_extra_row: 0,
      extra_amount: 0,
      previous_amt: 0
    };
  },
  props: [
    "is_generate_invoice_for_cost_plus",
    "project_details",
    "selected_rows",
    "is_update_invoice",
    "generate_invoice_id"
  ],
  watch: {
    is_generate_invoice_for_cost_plus: function(value) {
      this.items = [];
      if (value) {
        this.selected_rows = this.selected_rows.filter(item => {
          if (item.invoice_amt) {
            item.inv_amt = parseFloat(item.invoice_amt).toFixed(2);
            item.display_inv_amt = parseFloat(
              this.getAmountFormat(item.invoice_amt)
            ).toFixed(2);
          } else {
            item.inv_amt = this.getInvoiceAmt(item);
            item.display_inv_amt = parseFloat(
              this.getAmountFormat(item.invoice_amt)
            ).toFixed(2);
          }
          return item;
        });
        let project_data_flag = "";
        if (this.project_details.project_work.length > 0) {
          if (this.project_details.project_work == "remodeling") {
            project_data_flag = 2;
          } else if (this.project_details.project_work == "new_construction") {
            project_data_flag = 1;
          } else if (
            this.project_details.project_work == "project_management"
          ) {
            project_data_flag = 4;
          }
        }
        this.loading = true;
        axios
          .get(
            "get_item_group?project_id=" +
              this.project_details.project_id +
              "&project_data_flag=" +
              project_data_flag +
              "&is_update_invoice=" +
              this.is_update_invoice +
              "&generate_invoice_id=" +
              this.generate_invoice_id +
              "&is_from=transaction&p_type=cost_plus"
          )
          .then(response => {
            let response_data = response.data;
            this.items = response_data.data;
            this.previous_amt = response_data.previous_amt;

            this.items.filter(item2 => {
              let current_amount = 0;
              let final_amount = 0;
              this.selected_rows.filter(item3 => {
                if (item3.invoice_group_id == item2.invoice_group_id) {
                  current_amount += parseFloat(item3.amount);

                  if (item3.inv_amt < 0) {
                    final_amount -= parseFloat(item3.display_inv_amt);
                  } else {
                    final_amount += parseFloat(item3.display_inv_amt);
                  }
                }
                item2.total_group_amount = current_amount.toFixed(2);
                item2.final_group_amount = final_amount.toFixed(2);
                item2.last_group_amount = (
                  parseFloat(item2.final_group_amount) +
                  parseFloat(item2.previous_group_amount)
                ).toFixed(2);
              });
            });
            console.log(this.items, "this.items");
            // setTimeout(() => {
            this.items = this.items.filter(item => {
              if (item.total_group_amount != 0) {
                return item;
              }
            });
            // }, 500);

            this.loading = false;
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  },
  computed: {
    total_amt() {
      let total = 0;
      this.items.filter(item => {
        total += parseFloat(item.total_group_amount);
      });
      return parseFloat(total).toFixed(2);
    },
    final_amt() {
      let total = 0;
      this.items.filter(item => {
        total += parseFloat(item.final_group_amount);
      });
      return parseFloat(total).toFixed(2);
    },
    last_amt() {
      let total = 0;
      this.items.filter(item => {
        total +=
          parseFloat(item.final_group_amount) +
          parseFloat(item.previous_group_amount);
      });
      return parseFloat(total).toFixed(2);
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getTransacionVal() {
      var total = 0;
      this.trans_items.filter(item2 => {
        total += item2.rev_amount ? parseFloat(item2.rev_amount) : 0;
      });
      total = this.getAmountFormat(total);

      return parseFloat(total).toFixed(2);
    },
    updateInvoiceAmt() {
      let total = 0;
      console.log("this.selected_rows", this.selected_rows);
      console.log("this.trans_items", this.trans_items);

      this.selected_rows = this.selected_rows.filter(item => {
        this.trans_items.filter(item2 => {
          if (item2.trans_id == item.trans_id) {
            if (item2.display_inv_amt == this.getAmountFormat(item2.inv_amt)) {
              total += parseFloat(item2.inv_amt);
            } else {
              if (item2.inv_amt < 0) {
                total -= parseFloat(item2.display_inv_amt);
              } else {
                total += parseFloat(item2.display_inv_amt);
              }
            }
          }
        });
        return item;
      });
      let id = this.selected_group.invoice_group_id;
      this.items = this.items.filter(item => {
        if (item.invoice_group_id == id) {
          item.final_group_amount = parseFloat(total);
          item.last_group_amount = (
            parseFloat(total) + parseFloat(item.previous_group_amount)
          ).toFixed(2);
        }
        return item;
      });
      this.change_tran_amt_dialog = false;
    },

    getInvoiceAmt(item) {
      let total = this.getAmountFormat(item.rev_amount);
      return parseFloat(total).toFixed(2);
    },
    getAmountFormat(value) {
      if (value) {
        return value.toString().replace("-", "");
      } else {
        return 0;
      }
    },
    getFormatedDate(date) {
      return moment(date).format("MM/DD/YY");
    },
    changeTranAmtDialog(item) {
      console.log(item);
      this.selected_group = item;

      this.updated_current_amount = item.total_group_amount;

      this.trans_items = this.selected_rows.filter(item2 => {
        if (item2.invoice_group_id == item.invoice_group_id) {
          return item;
        }
      });

      var total = 0;
      this.trans_items.filter(item3 => {
        total += parseFloat(item3.inv_amt);
        item3.inv_amt = parseFloat(item3.inv_amt).toFixed(2);
      });

      this.updated_amt_total = parseFloat(total);
      this.display_updated_amt_total = this.getAmountFormat(parseFloat(total));
      if (total > item.total_group_amount) {
        this.invoice_btn_flag = true;
      }
      this.change_tran_amt_dialog = true;
    },
    getTotalUpdatevalue() {
      var total = 0;
      this.trans_items.filter(item2 => {
        if (item2.display_inv_amt == this.getAmountFormat(item2.inv_amt)) {
          total += parseFloat(item2.inv_amt);
        } else {
          if (item2.inv_amt < 0) {
            total -= parseFloat(item2.display_inv_amt);
          } else {
            total += parseFloat(item2.display_inv_amt);
          }
        }
      });
      this.updated_amt_total = parseFloat(total).toFixed(2);
      this.updated_amt_total =
        this.updated_amt_total != 0 ? this.updated_amt_total : 0;
      this.display_updated_amt_total = this.getAmountFormat(
        this.updated_amt_total
      );
    },
    generateInvoice() {
      this.generate_invoice_loading = true;
      axios
        .post("generate_invoice", {
          items: this.items,
          selected_rows: this.selected_rows,
          project_details: this.project_details,
          is_update_invoice: this.is_update_invoice,
          generate_invoice_id: this.generate_invoice_id
        })
        .then(res => {
          this.setAlert({
            show: true,
            variant: "primary",
            message: res.data.message,
            dismissCountDown: 0
          });
          this.generate_invoice_loading = false;
          this.$emit("successGenerateInvoice");
          this.$emit("closeDialog");
        })
        .catch(() => {
          this.generate_invoice_loading = false;
        });
    }
  }
};
</script>
<style>
.error--text input {
  color: #a61f38 !important;
}
.primary--text input {
  color: #6e9a35 !important;
}
</style>